import React from "react";
import { TextField, useTheme } from "@mui/material";

const TextInput = ({ id, label, value, onChange, errorText = null, type="text", disabled = false, mt = 0, mb = 0 }) => {
    const theme = useTheme();
    return (
        <TextField
            fullWidth
            size="small"
            disabled={disabled}
            id={id}
            name={id}
            label={label}
            type={type}
            value={value ?? ""}
            onChange={onChange}
            error={Boolean(errorText)}
            helperText={errorText}
            margin="none"
            sx={{ marginTop: theme.spacing(mt), marginBottom: theme.spacing(mb) }}
        />
    );
};

export default TextInput;
